import { createMuiTheme } from '@material-ui/core';
import { GLOBAL_FONT_THEME } from 'theme/CommonTheme';

export const FILLED_TEXTFIELD_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiFormLabel: {
            root: {
                color: '#7b7a86',
                fontSize: '0.9rem',
                fontFamily: 'Open Sans !important',
                fontWeight: 600,
                '&$focused': {
                    color: '#005F9E'
                }
            }
        },
        MuiSelect: {
            selectMenu: {
                height: '1.25em'
            }
        },
        MuiFormControl: {
            marginNormal: {
                marginTop: -2
            },
            marginDense: {
                marginTop: 10,
                marginBottom: 5
            },
            root: {
                width: 'inherit'
            }
        },
        MuiGrid: {
            container: {
                paddingTop: 15
            },
            'grid-xs-6': {
                paddingLeft: 15
            },
            root: {
                width: 'inherit'
            }
        },
        MuiInputBase: {
            root: {
                lineHeight: 'unset'
            },
            inputMarginDense: {
                paddingLeft: 10
            },
            input: {
                fontFamily: "'Open Sans', sans-serif",
                fontSize: '0.95rem',
                fontWeight: 500,
                color: '#000',
                height: '1.25em'
            }
        },
        MuiTypography: {
            body1: {
                fontSize: '0.95rem'
            }
        },
        MuiInput: {
            underline: {
                '&$disabled:before': {
                    borderBottomStyle: 'solid'
                },
                '&:hover:not($disabled):not($error):not($focused):before': {
                    height: 1
                },
                '&:before': {
                    borderBottom: '1px solid #005F9E'
                },
                '&:after': {
                    borderBottom: '2px solid #005F9E'
                }
            }
        },
        MuiFilledInput: {
            root: {
                backgroundColor: '#eeeeee'
            },
            underline: {
                '&$disabled:before': {
                    borderBottomStyle: 'solid'
                },
                '&:hover:not($disabled):not($error):not($focused):before': {
                    borderBottomColor: '#009ad9',
                    height: 1
                },
                '&:before': {
                    borderBottom: '2px solid #009ad9'
                },
                '&:after': {
                    borderBottom: '2px solid #009ad9'
                }
            }
        },
        MuiList: {
            root: {
                position: 'initial'
            }
        },
        MuiRadio: {
            colorSecondary: {
                '&$checked': {
                    color: '#009ad9 !important'
                }
            }
        },
        MuiFormGroup: {
            row: {
                justifyContent: 'space-between',
                width: '80% !important'
            }
        }
    }
});

export const INTEGRATION_TYPES_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiGrid: {
            item: {
                paddingLeft: 20,
                paddingRight: 20,
                paddingTop: 5
            }
        },
        MuiFormLabel: {
            root: {
                color: '#7b7a86',
                fontSize: '0.9rem',
                fontFamily: 'Open Sans !important',
                fontWeight: 600,
                '&$focused': {
                    color: '#005F9E'
                }
            }
        },
        MuiInputBase: {
            root: {
                lineHeight: 'unset'
            },
            inputMarginDense: {
                paddingLeft: 10
            },
            input: {
                fontFamily: "'Open Sans', sans-serif",
                fontSize: '0.95rem',
                fontWeight: 500,
                color: '#000',
                height: '1.25em'
            }
        },
        MuiTypography: {
            body1: {
                fontSize: '0.95rem'
            }
        },
        MuiInput: {
            underline: {
                '&$disabled:before': {
                    borderBottomStyle: 'solid'
                },
                '&:hover:not($disabled):not($error):not($focused):before': {
                    height: 1
                },
                '&:before': {
                    borderBottom: '1px solid #005F9E'
                },
                '&:after': {
                    borderBottom: '2px solid #005F9E'
                }
            }
        },
        MuiFilledInput: {
            root: {
                backgroundColor: '#eeeeee'
            },
            underline: {
                '&$disabled:before': {
                    borderBottomStyle: 'solid'
                },
                '&:hover:not($disabled):not($error):not($focused):before': {
                    borderBottomColor: '#009ad9',
                    height: 1
                },
                '&:before': {
                    borderBottom: '2px solid #009ad9'
                },
                '&:after': {
                    borderBottom: '2px solid #009ad9'
                }
            }
        },
        MuiFormControlLabel: {
            root: {
                paddingLeft: 20
            }
        },
        MuiFormControl: {
            root: {
                width: '100%'
            }
        },
        MuiCheckbox: {
            colorSecondary: {
                '&$checked': {
                    color: '#009ad9 !important'
                }
            }
        }
    }
});

export const DIALOG_THEME = createMuiTheme({
    overrides: {
        MuiDialogContentText: {
            root: {
                whiteSpace: 'pre'
            }
        }
    }
});

export const FILLED_INPUT_SELECT_THEME = createMuiTheme({
    overrides: {
        MuiFormControl: {
            root: {
                width: '100%',
                fontWeight: '500',
                marginTop: '8px'
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: '2px !important',
                borderTopRightRadius: '2px !important',
                position: 'absolute'
            },
            input: {
                fontSize: '16px !important',
                color: '#282828 !important'
            },
            underline: {
                '&$disabled:before': {
                    borderBottomStyle: 'solid'
                },
                '&:hover:not($disabled):not($error):not($focused):before': {
                    borderBottomColor: '#009ad9',
                    height: 1
                },
                '&:before': {
                    borderBottom: '2px solid #009ad9'
                },
                '&:after': {
                    borderBottom: '2px solid #009ad9'
                }
            }
        },
        MuiFormHelperText: {
            contained: {
                margin: '8px 0 0'
            },
            root: {
                color: 'red',
                paddingLeft: '10px',
                marginTop: '10px'
            }
        },
        MuiFormLabel: {
            root: {
                fontWeight: 600,
                fontSize: '14px  !important',
                fontFamily: 'inherit',
                paddingLeft: '10px',
                paddingTop: '20px'
            }
        },
        MuiInputBase: {
            root: {
                height: '50px'
            }
        },
        MuiInputLabel: {
            formControl: {
                top: 0,
                left: 0,
                position: 'absolute'
            },
            shrink: {
                paddingTop: 10
            }
        }
    }
});

export const INTEGRATION_OPTIONS_THEME = createMuiTheme({
    overrides: {
        MuiFormControl: {
            root: {
                width: '100%',
                fontWeight: '500',
                marginTop: '8px',
                marginBottom: '60px'
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: '2px !important',
                borderTopRightRadius: '2px !important',
                position: 'absolute'
            },
            input: {
                fontSize: '16px !important',
                color: '#282828 !important'
            },
            underline: {
                '&$disabled:before': {
                    borderBottomStyle: 'solid'
                },
                '&:hover:not($disabled):not($error):not($focused):before': {
                    borderBottomColor: '#009ad9',
                    height: 1
                },
                '&:before': {
                    borderBottom: '2px solid #009ad9'
                },
                '&:after': {
                    borderBottom: '2px solid #009ad9'
                }
            }
        },
        MuiFormHelperText: {
            contained: {
                margin: '8px 0 0'
            },
            root: {
                color: 'red',
                paddingLeft: '10px',
                marginTop: '50px',
                position: 'absolute'
            }
        },
        MuiFormLabel: {
            root: {
                fontWeight: 600,
                fontSize: '14px  !important',
                fontFamily: 'inherit',
                paddingLeft: '10px'
            }
        },
        MuiInputBase: {
            root: {
                height: '50px'
            }
        },
        MuiInputLabel: {
            formControl: {
                top: 0,
                left: 0,
                position: 'absolute'
            },
            shrink: {
                paddingTop: 10
            }
        }
    }
});
